export * from './baKameleonPicture.pipe';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/pipes/baKameleonPicture/index.ts